import { Routes, Route, Navigate } from "react-router-dom";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import List from "./List/List";
import { New } from "./New/New";
import { Edit } from "./Edit/Edit";

const AttachmentTypesMspa = (): JSX.Element => {
  const { hasPrivilege, privilegesLoading } = usePrivilegeCheck();

  if (privilegesLoading) return <ScopeStackSpinner />;

  if (
    !hasPrivilege("settings.attachment_types", ["view", "create", "manage"])
  ) {
    return (
      <div className="p-3">You do not have access to Attachment Types.</div>
    );
  }

  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="new" element={<New />} />
      <Route path=":id/edit" element={<Edit />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default AttachmentTypesMspa;
